import { configVars } from 'src/helpers';
import { defaultInstance } from './instance';

export enum RentVerificationStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled'
}
export interface RentVerification {
  id: string;
  applicant_id: string;
  property_id: string;
  provider: 'trigo';
  external_id: string;
  status: RentVerificationStatus;
  report_url?: string;
  request_payload?: Record<string, unknown>;
  provider_data?: Record<string, unknown>;
  inserted_at: string;
  updated_at: string;
  applicant_full_name: string;
  property_name: string;
}

export interface RentVerificationListResponse {
  data: RentVerification[];
  page: number;
  rowsPerPage: number;
  total: number;
}

export interface GetRentVerificationsParams {
  page?: string;
  rowsPerPage?: string;
  q?: string;
  sort?: string;
  filter?: string;
}

class RentVerificationApi {
  async getRentVerifications(
    page?: string,
    rowsPerPage?: string,
    filter?: string,
    sort?: string,
    q?: string
  ): Promise<RentVerificationListResponse> {
    const params: GetRentVerificationsParams = {};

    if (page) params.page = page;
    if (rowsPerPage) params.rowsPerPage = rowsPerPage;
    if (filter) params.filter = filter;
    if (sort) params.sort = sort;
    if (q) params.q = q;

    return defaultInstance.get(`${configVars.api_url}/rent_verifications`, { params });
  }
}

export const rentVerificationApi = new RentVerificationApi();
